import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const el = document.getElementById('hero-cta');
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);
  return <AnimatePresence data-id="element-169" data-mp="2aus1sf5ot7uz">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 flex justify-center bg-navy-950/90 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur-sm" data-id="element-170" data-mp="2atqnm1tdk591">
          <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full max-w-md items-center justify-center gap-2 rounded-2xl border-b-4 border-gold-600 bg-gold-400 px-4 py-4 text-center text-base font-extrabold uppercase text-navy-900 shadow-xl focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-200" data-id="element-171" data-mp="335nfbhexl10f">
            Get the Blueprint — $27
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-172" data-mp="2kectheo2befe" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}